import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { FaHeart, FaRocket, FaUsers, FaAngleLeft, FaAngleRight } from 'react-icons/fa';
import 'bootstrap/dist/css/bootstrap.min.css';
import './AboutUs.css';

const AboutUs = () => {
  const sections = ['mission', 'commitment', 'joinUs'];
  const [currentSectionIndex, setCurrentSectionIndex] = useState(0);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentSectionIndex((prevIndex) => (prevIndex + 1) % sections.length);
    }, 15000); 

    return () => clearInterval(intervalId); 
  }, []);


  const goToPreviousSection = () => {
    setCurrentSectionIndex((prevIndex) => (prevIndex - 1 + sections.length) % sections.length);
  };

  const goToNextSection = () => {
    setCurrentSectionIndex((prevIndex) => (prevIndex + 1) % sections.length);
  };
  const renderSection = () => {
    switch (sections[currentSectionIndex]) {
      case 'mission':
        return renderMission();
      case 'commitment':
        return renderCommitment();
      case 'joinUs':
        return renderJoinUs();
      default:
        return null;
    }
  };

  const renderSectionWithNavigation = () => (
    <div className="about-card color-switch mb-4">
      {renderSection()}
      <div className="button-container">
        <button className="navigation-button previous" onClick={goToPreviousSection}>
          <FaAngleLeft />
        </button>
        <button className="navigation-button next" onClick={goToNextSection}>
          <FaAngleRight />
        </button>
      </div>
    </div>
  );

  const renderMission = () => (
    <>
      <div className="about-icon-container text-center mb-3">
        <FaRocket className="about-icon" />
      </div>
      <h2 className="text-center">Our Mission</h2>
      <p>
        To empower businesses and individuals alike with cutting-edge web solutions that not only meet but exceed quality expectations in this rapid technological era. Everyone deserves access to high-quality digital products, and we're here to ensure they get just that.
      </p>
    </>
  );

  const renderCommitment = () => (
    <>
      <div className="about-icon-container text-center mb-3">
      <FaHeart className="about-icon" /> 
    </div>
      <h2 className="text-center">Our Commitment</h2>
      <p>
        At WebCraft Wizards, our commitment is to you - our valued client. We pledge to deliver exceptional services that not only meet your needs but also anticipate future demands, ensuring your digital experience is seamless, efficient, and, above all, enjoyable.
      </p>
    </>
  );

  const renderJoinUs = () => (
    <>
      <div className="about-icon-container text-center mb-3">
        <FaUsers className="about-icon" />
      </div>
      <h2 className="text-center">Join Us</h2>
      <p>
        Embark on a journey with WebCraft Wizards and discover the true potential of your online presence. Let's create, innovate, and elevate together. Your digital adventure starts here.
      </p>
    </>
  );

  return (
    <Container className="about-us-container">
      <Row className="about-row mb-5">
        <Col>
          <h1 className="about-title text-center"style={{ color: "#8d2ab6" }}>Welcome to WebCraft Wizards!</h1>
        </Col>
      </Row>
      <Row>
        <Col className="d-flex justify-content-center">
          {renderSectionWithNavigation()}
        </Col>
      </Row>
    </Container>
  );
};

export default AboutUs;
